<template>
  <div class="reset">
    <!-- pc端头部 -->
    <house-pc-header class="reset_pc_header">
      <span>{{ lang.userSetLang }}</span>
    </house-pc-header>
    <div class="reset_pc_block">
      <!-- wap端头部 -->
      <house-wap-header class="reset_wap_header">
        <span>{{ lang.resetPasswordLang }}</span>
      </house-wap-header>
      <div class="reset_pc_bar">
        <progress-bar step="2"></progress-bar>
      </div>
      <p class="info_success reset_pc_info">{{ lang.webSuccessLang }}</p>
      <house-form :type="'reset'" :error="error" class="reset_pc_form reset_wap_form" :errorLeft="errorLeftStyle">
        <house-form-item :label="lang.newPasswordLang" class="reset_wap_form_item reset_pc_form_item">
          <house-input :placeholder="lang.resetPasswordPointLang" v-model.trim="firstPassword" class="reset_pc_input" :type="eyeTypeFrist"></house-input>
          <svg class="icon icon_eye" aria-hidden="true" @click="eyeOpen('Frist')">
            <use :xlink:href="eyeSvgFrist"></use>
          </svg>
        </house-form-item>
        <house-form-item :label="lang.makeSureLang" class="reset_wap_form_item reset_pc_form_item">
          <house-input :placeholder="lang.againPasswordPointLang" v-model.trim="secondPassword" class="reset_pc_input" :type="eyeTypeSecond" @keyupEnter="nextBtn">></house-input>
          <svg class="icon icon_eye" aria-hidden="true" @click="eyeOpen('Second')">
            <use :xlink:href="eyeSvgSecond"></use>
          </svg>
        </house-form-item>
      </house-form>
      <div class="red_btn" :class="nextLightBtn ? 'red_active' : ''" @click="nextBtn">{{ lang.nextLang }}</div>
    </div>
  </div>
</template>

<script>
import lang from '../../../common/language/new_login';
import houseWapHeader from '../../components/houseLogin/houseWapHeader';
import progressBar from '../../components/houseLogin/progressBar';
import housePcHeader from '../../components/houseLogin/housePcHeader';
import houseForm from '../../components/houseLogin/houseForm';
import houseFormItem from '../../components/houseLogin/houseFormItem.vue';
import houseInput from '../../components/houseLogin/houseInput.vue';
import pub from '../../../common/public';
export default {
  created() {
    let key = this.$route.query.key;
    if (key) {
      this.key = key;
    } else {
      this.key = '';
    }
  },
  data() {
    return {
      firstPassword: '',
      secondPassword: '',
      error: '',
      key: '',
      lang: lang,
      eyeTypeFrist: 'password', //密码显示隐藏
      eyeTypeSecond: 'password', //密码显示隐藏
      eyeSvgFrist: '#icon-yincangmima', //密码icon
      eyeSvgSecond: '#icon-yincangmima' //密码icon
    };
  },
  methods: {
    // del(type) {
    //   if (type == 'firstPassword') {
    //     this.firstPassword = '';
    //   } else {
    //     this.secondPassword = '';
    //   }
    // },

    eyeOpen(type) {
      this[`eyeType${type}`] == 'password' ? (this[`eyeType${type}`] = 'text') : (this[`eyeType${type}`] = 'password');
      this[`eyeSvg${type}`] == '#icon-yincangmima' ? (this[`eyeSvg${type}`] = '#icon-xianshimima') : (this[`eyeSvg${type}`] = '#icon-yincangmima');
    },
    nextBtn() {
      let oneVaildator = pub.passwordValidator(this.firstPassword);
      let twoVaildator = pub.passwordValidator(this.secondPassword);
      if (!this.nextLightBtn || this.error) return;
      console.log(1111111);
      if (oneVaildator != 0 || twoVaildator != 0) {
        this.error = this.lang.errPasswordFormLang;
      } else if (this.firstPassword != this.secondPassword) {
        this.error = this.lang.errSamePasswordLang;
      } else {
        this.axios
          .post(pub.getApi().ResetPassword, {
            key: this.key || 'ff995ee8b1f5404a8f0f35129467a37',
            password: this.firstPassword
          })
          .then(res => {
            if (res.data.code == 0) {
              this.$router.push('/success');
            } else {
              this.error = this.lang.NoInterNetLang;
            }
          });
      }
    }
  },
  computed: {
    nextLightBtn() {
      if (this.firstPassword && this.secondPassword) {
        return true;
      } else {
        return false;
      }
    },
    errorLeftStyle() {
      if (document.body.scrollWidth > 600 && window._language == 'en-us') {
        console.log('确认');
        return 'left:200px';
      }
    }
  },
  components: {
    houseForm,
    houseFormItem,
    houseInput,
    houseWapHeader,
    housePcHeader,
    progressBar
  },
  watch: {
    firstPassword(value) {
      let result = pub.passwordValidator(value);
      if (result != 0) {
        this.error = this.lang.errPasswordFormLang;
      } else {
        this.error = '';
      }
    },
    secondPassword(value) {
      let result = pub.passwordValidator(value);
      if (result != 0) {
        this.error = this.lang.errPasswordFormLang;
      } else {
        this.error = '';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import url('../../assets/base.css');
.reset {
  padding: 0 15px;
  .info_success {
    padding: 40px 0;
    color: #333;
    font-size: 20px;
    font-weight: 500;
  }
  .reset_pc_header {
    display: none;
  }
  .icon_eye {
    cursor: pointer;
    font-size: 30px;
    color: #b9b9b9;
  }
  .reset_wap_form_item {
    border-bottom: 1px solid #eee;
    /deep/.label {
      display: none;
    }
  }
  .reset_wap_form_item:hover {
    border-bottom: 1px solid red;
  }
  .reset_pc_bar {
    display: none;
  }
  .red_btn {
    margin-top: 35px;
  }
}

@media screen and (min-width: 601px) {
  .reset {
    overflow: auto;
    height: 100%;
    background-color: #f4f4f4;
    padding: 0;
    .reset_pc_header {
      display: block;
    }
  }
  .reset_wap_header {
    display: none;
  }
  .reset_pc_block {
    background-color: #fff;
    margin: 0 auto;
    margin-top: 40px;
    width: 1200px;

    padding-bottom: 130px;
    font-size: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
    .reset_pc_info {
      font-size: 16px;
      color: #333333;
    }
    .reset_pc_bar {
      display: block;
    }
    .reset_pc_form {
      /deep/.info_err {
        left: 110px;
      }
    }
    .red_btn {
      width: 400px;
      margin-left: 98px;
      margin-top: 50px;
    }
    .reset_wap_form_item {
      border: none;
    }
    .reset_wap_form_item:hover {
      border: none;
    }
    .reset_pc_form_item {
      .reset_pc_input {
        position: relative;
        width: 400px;
        padding: 0 10px;
        border: 1px solid #eee;
        border-radius: 4px;
      }
      .reset_pc_input:hover {
        border: 1px solid red;
      }
      .icon_eye {
        background-color: #fff;
        z-index: 99;
        position: absolute;
        right: 20px;
      }
      /deep/.label {
        display: block;
      }
    }
    .reset_pc_form_item:nth-of-type(1) {
      margin-bottom: 25px;
    }
  }
}
</style>
